/*
 *  capsulation of http request,use 'fly',vue-resource alternative
 *  see detail in https://github.com/wendux/fly
 */

import Fly from 'flyio/dist/npm/fly'
import env from '@/env'
import config from '@/config'
// import oAuth from '@/utils/oAuth'
// import { toParams } from '@/utils/to-params'
import qs from 'qs'
import { Toast } from 'vant'
const fly = new Fly()
fly.config.baseURL = env.host + env.baseURL
fly.config.withCredentials = true
// request setting
fly.interceptors.request.use(async function (request) {
  request.headers['act-id'] = window.$inrice.actID
  if (config.authenticator === 'jwt' && config.jwtConfig.authWhiteList.indexOf(request.url) < 0) {
    // 非白名单,则开启校验
    const storageType = env.storageType || config.jwtConfig.storageType || 'localStorage'
    const tokenText = env.token || config.jwtConfig.token || 'token'
    const tokenTypeText = env.tokenType || config.jwtConfig.tokenType || 'tokenType'
    const token = window[storageType].getItem(tokenText)
    // const token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOi8vYXBpLnFoZC5pbnJpY2UudG9wL2FwaS9ibGVzc2luZy1jYXJkL21vY2svdXNlciIsImlhdCI6MTU4MTk5MTA4MSwiZXhwIjoxNTgyMDc3NDgxLCJuYmYiOjE1ODE5OTEwODEsImp0aSI6IkNrcm1icmxwZ01vdjRIOW8iLCJzdWIiOjY4LCJwcnYiOiJhMzZkMzg4OTEwZDk2Yzk3ODE4YjM2MDhkOWZjMzA5NDI2ZmE0ZmQxIn0.-bOj5AQQ42NuAFnpJftZoAYJ1SKK4KOH7Hqx_yMJ03o'
    const tokenType = window[storageType].getItem(tokenTypeText)
    if (!token) {
      location.href = `auth.html?${qs.stringify({
        appID: window.$inrice.appID,
        actID: window.$inrice.actID,
        href: encodeURIComponent(location.origin + location.pathname),
        search: encodeURIComponent(location.search),
        hash: encodeURIComponent(location.hash)
      })}`
    } else {
      request.headers.Authorization = `${tokenType} ${token}`
      return request
    }
  }
})

fly.interceptors.response.use(async function (config, promise) {
  return config
}, async function (error, promise) {
  if (error.status === 401) {
    // 如果此时有token,清除token
    const storageType = env.storageType || config.jwtConfig.storageType || 'localStorage'
    const tokenText = env.token || config.jwtConfig.token || 'token'
    const token = window[storageType].getItem(tokenText)
    if (token) {
      // 一旦出现401,立即删除token
      window[storageType].removeItem(tokenText)
    }
    console.log('need location href to wxAuthUrl')
    // 重定向到授权页面
    location.href = `auth.html?${qs.stringify({
      appID: window.$inrice.appID,
      actID: window.$inrice.actID,
      href: encodeURIComponent(location.origin + location.pathname),
      search: encodeURIComponent(location.search),
      hash: encodeURIComponent(location.hash)
    })}`
    return promise.reject(error)
  } else if (error.status === 404 || error.status === 500) {
    console.error(error)
    Toast('网络错误!')
    return promise.reject(error)
  } else if (error.status === 429) {
    console.log('request are too fast')
    Toast('您太快了,请稍后重试!')
    return promise.reject(error)
  } else if (error.status === 403) {
    console.log('forbidden request')
    console.error(error)
    Toast('您无权访问')
    return promise.reject(error)
  } else {
    // 其他请求,直接抛出让业务去处理
    return promise.reject(error)
  }
})

export default fly
